/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../../../../components/ui-elements/table/StyledTableRow';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { BsFillPencilFill } from 'react-icons/bs';
import {  useSelector } from 'react-redux';
import DialogContainer from '../../../../../../../../components/shared/Dialog/DialogContainer';
import { FaHistory } from 'react-icons/fa';
import OrgAppDeviceEdit from './OrgAppDeviceEdit';
import OrgAppDeviceHistory from './OrgAppDeviceHistory';

const OrgAppsDevices = () => {
    const [selectedOrgAppsDevices, setSelectedOrgAppsDevices] = useState({});
    const [openEditOrgAppsDevices, setOpenEditOrgAppsDevices] = useState(false);
    const [openHistoryOrgAppsDevices, setOpenHistoryOrgAppsDevices] = useState(false);
    const orgAppsDevicesList = useSelector(state => state.orgApplicationDevices.orgAppsDevicesList)

    const handleCloseDialog = () => {
        setOpenEditOrgAppsDevices(false);
        setOpenHistoryOrgAppsDevices(false);
    }

    return (
        <><TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                    <StyledTableRow>
                        <StyledTableCell label="Organization Name" />
                        <StyledTableCell label="Device Name" />

                        <StyledTableCell label="Role Name" />
                        <StyledTableCell label="Details" />
                        <StyledTableCell label=" " />

                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {orgAppsDevicesList?.Records?.length > 0 && orgAppsDevicesList.Records.map((row) => (
                        <StyledTableRow key={row.organizationID}>
                            <StyledTableCell label={row.organizationName} />
                            <StyledTableCell label={row.deviceName} />
                            <StyledTableCell label={row.roleName} />

                            <StyledTableCell   >
                                {row.organizationApplicationDeviceDetails.length > 0 ?
                                    <Typography style={{ fontWeight: 'bold' }} color={row.organizationApplicationDeviceDetails[0].detailValue === "true" ? 'primary' : 'error'}>
                                        {row.organizationApplicationDeviceDetails[0].detailValue === "true" ? 'Authorized' : 'Unauthorized'}
                                    </Typography> : "N/A"}
                            </StyledTableCell>

                            <StyledTableCell align="right"  >
                                <Tooltip title={row.organizationName + " " + row.deviceName + "  Edit"} placement="left" arrow>

                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedOrgAppsDevices(row); setOpenEditOrgAppsDevices(true) }}>
                                        <BsFillPencilFill />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={row.organizationName + " " + row.deviceName + "  History"} placement="left" arrow>

                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedOrgAppsDevices(row); setOpenHistoryOrgAppsDevices(true) }}>
                                        <FaHistory />
                                    </IconButton>
                                </Tooltip>
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>


            <DialogContainer
                open={openEditOrgAppsDevices}
                handleClose={handleCloseDialog}
            >
                <OrgAppDeviceEdit
                    selectedOrgAppDevice={selectedOrgAppsDevices}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
            <DialogContainer
                open={openHistoryOrgAppsDevices}
                handleClose={handleCloseDialog}
            >
                <OrgAppDeviceHistory
                    selectedOrgAppDevice={selectedOrgAppsDevices}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}


export default OrgAppsDevices;
